module.exports = __webpack_public_path__ + "static/media/settings.674d9d35.svg";